import React from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';

const contentStyle = {
  border: 'none',
  borderRadius: '8px',
  boxShadow: '0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)',
  width: '420px',
  maxWidth: 'calc(100vw - 24px)',
  padding: '0'
};

// O-5024: shared confirm for the event-template controls. The three actions it
// guards each rewrite a budget every artist on the show shares, so they get a
// real dialog — labelled, focus-managed and escapable — rather than
// window.confirm or no prompt at all.
const TemplateConfirmDialog = ({
  open,
  title,
  body,
  confirmLabel,
  busyLabel,
  busy,
  destructive,
  onConfirm,
  onCancel,
  testId
}) => (
  <Popup
    open={open}
    onClose={onCancel}
    modal
    closeOnDocumentClick={!busy}
    closeOnEscape={!busy}
    contentStyle={contentStyle}
    className="template-confirm-popup"
  >
    <div
      style={{ padding: '20px' }}
      role="dialog"
      aria-modal="true"
      aria-labelledby={`${testId}-title`}
      data-testid={testId}
    >
      <h5
        id={`${testId}-title`}
        style={{ marginBottom: '12px', fontWeight: '600', fontSize: '16px' }}
      >
        {title}
      </h5>
      <p style={{ fontSize: '14px', color: 'var(--bk-c-414651, #414651)', marginBottom: '16px' }}>
        {body}
      </p>
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        {/* Focus lands on Cancel when the action is destructive: this dialog
          * guards rebuilding a whole show's budget, and a stray Enter — from
          * the keystroke that opened it — should not be what does it. */}
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          style={{ borderRadius: '6px' }}
          onClick={onCancel}
          disabled={busy}
          autoFocus={destructive}
        >
          Cancel
        </button>
        <button
          type="button"
          className={`btn btn-sm ${destructive ? 'btn-danger' : 'btn-primary'}`}
          style={{ borderRadius: '6px' }}
          onClick={onConfirm}
          disabled={busy}
          autoFocus={!destructive}
          data-testid={`${testId}-submit`}
        >
          {busy ? busyLabel : confirmLabel}
        </button>
      </div>
    </div>
  </Popup>
);

TemplateConfirmDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.node,
  body: PropTypes.node,
  confirmLabel: PropTypes.string,
  busyLabel: PropTypes.string,
  busy: PropTypes.bool,
  destructive: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  testId: PropTypes.string.isRequired
};

TemplateConfirmDialog.defaultProps = {
  open: false,
  title: null,
  body: null,
  confirmLabel: 'Confirm',
  busyLabel: 'Working...',
  busy: false,
  destructive: false
};

export default TemplateConfirmDialog;
